export const STATUSES = {
  updated: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#1F9C3A" />
      <path
        d="M8.83877 4.54846L5.4678 7.91943L3.93555 6.38717"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  outdated: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#FFBA24" />
      <path
        d="M6.00035 3.94272V5.99986L7.37178 6.68557M9.42892 5.99986C9.42892 7.89341 7.8939 9.42843 6.00035 9.42843C4.1068 9.42843 2.57178 7.89341 2.57178 5.99986C2.57178 4.10631 4.1068 2.57129 6.00035 2.57129C7.8939 2.57129 9.42892 4.10631 9.42892 5.99986Z"
        stroke="white"
        stroke-width="0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  notStarted: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#CDCDCD" />
    </svg>
  ),
};
